<template>
     <section id="tour_details_main" class="section_padding">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="terms_service_content">
                      <div class="terms_item">
                        <h2>{{$t("review")}}</h2>
                        <br /><br />
                        <h4>{{$t("flypromsg")}}</h4>
                        <p>
                            <!--"https://hotels.flystaygo.com/v6/cancel-or-resend"    https://fly-stay-go.nuitee.link/manage-bookings-->
                            {{$t("flyproasst")}}<br />
                            <li><u><a href="/dashboard">{{$t("clickortap")}}</a></u> {{$t("flyproOne")}}</li>
                          <li>{{$t("flyproTwo")}}</li>
                        </p> 

                      </div>
                      <div class="terms_item">

                        <h4>{{$t("tourmsg")}}</h4>
                        <p>
                          {{$t("tourasst")}}<br />
                          <li> <!--<u><a href="https://www.viator.com/itinerary-login">{{$t("clickortap")}}</a></u>--> {{$t("tourOne")}}</li>

                        </p>


                      </div>
                      <div class="terms_item">
                        
                        <h4>{{$t("flymsg")}}</h4>
                        <p>
                          {{$t("flyasst")}}<br />
                          <li><u><a href="https://www.travelweb.com/trips/ppn/7513/lookup">{{$t("clickortap")}}</a></u> {{$t("flyOne")}}</li>
                          <li>{{$t("flyproTwo")}}</li>
                        </p>


                      </div>  
                        <div class="terms_item">
                         <br /><br />
                          <h4>{{$t("custphone")}}</h4>  <p v-html="$t('custphoneinfo')"></p><br />
                         <!-- <p>
                            {{$t("custphoneinfo")}}
                       
                          </p> -->
                        </div>
                      
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>
<script>

export default {
  name: "ReviewCancelContent"
};
</script>